import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";

const USER_FEEDBACK_GET = "USER_FEEDBACK_GET";

export const getUserFeedbacks = createAction(
  USER_FEEDBACK_GET,
  async (filters, page, itemPerPage) => {
    try {
      const result = await api.UserFeedback.list({ ...filters, page, itemPerPage });
      return {
        page,
        itemPerPage,
        userFeedbacks: result.data,
        total: result.count
      };
    } catch (e) {
      return { userFeedbacks: [] };
    }
  }
);

const defaultState = {
  page: 1,
  itemPerPage: 10,
  total: 0,
  userFeedbacks: [],
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload
});

export default handleActions(
  {
    [USER_FEEDBACK_GET]: updateState,
  },
  defaultState
);

export const selectUserFeedbacks = state => state.admin.userFeedbacks



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserFeedbackPage/userFeedback.ducks.ts